import { Component, Input, OnInit } from '@angular/core';
import { IEmployee } from '../../employee';
import { combineLatest, map } from 'rxjs';
import { EmployeeStore } from 'src/app/stores/component/employee.store';
import { TenantSettingsStoreService } from 'src/app/setting/tenant-settings/services/tenant-settings-store.service';

@Component({
    selector: 'app-employee-fiscal-year-report',
    templateUrl: './employee-fiscal-year-report.component.html',
    styleUrls: ['./employee-fiscal-year-report.component.css'],
    standalone: false
})
export class EmployeeFiscalYearReportComponent implements OnInit {

  constructor(
    private employeeStore: EmployeeStore,
    private tenantSettingsStore: TenantSettingsStoreService
  ) { }

  vm$ = combineLatest([
    this.employeeStore.employee$,
    this.tenantSettingsStore.tenantSettings$,
  ]).pipe(
    map(([
      employee,
      tenantSettings,
    ]) => ({
      employee,
      tenantSettings,
    }))
  );

  ngOnInit(): void {
  }

}
